<script setup lang="ts">
withDefaults(defineProps<{
  color?: string;
}>(), {
  color: "#FFFFFF"
});
</script>

<template>
  <div class="loading-circle-icon" aria-hidden="true" role="none">
    <svg width="16" height="16" viewBox="0 0 16 16" role="none" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.7465 6.3232C15.3083 6.18355 15.8843 6.52604 15.9494 7.10132C16.1163 8.57778 15.8693 10.0792 15.2256 11.4337C14.4313 13.1053 13.0818 14.4499 11.4072 15.2382C9.73263 16.0264 7.83653 16.2097 6.04198 15.7567C4.24743 15.3037 2.66547 14.2425 1.56564 12.7538C0.465814 11.2652 -0.083828 9.4413 0.0103672 7.59285C0.104562 5.74441 0.836766 3.98581 2.08222 2.6167C3.32767 1.24759 5.00932 0.352684 6.84062 0.0844558C8.32444 -0.132878 9.83213 0.0721089 11.1944 0.665422C11.7252 0.896595 11.8833 1.54781 11.5848 2.04384C11.2863 2.53986 10.6439 2.68999 10.1029 2.48376C9.16607 2.12662 8.14787 2.01188 7.14445 2.15885C5.79307 2.35678 4.55213 3.01717 3.63307 4.02748C2.714 5.03779 2.17368 6.33552 2.10417 7.69955C2.03466 9.06358 2.44026 10.4095 3.25186 11.508C4.06346 12.6065 5.23085 13.3896 6.55511 13.7239C7.87937 14.0582 9.27857 13.923 10.5143 13.3413C11.75 12.7596 12.7458 11.7674 13.3321 10.5338C13.7673 9.61786 13.9568 8.61088 13.8906 7.61043C13.8524 7.03276 14.1846 6.46284 14.7465 6.3232Z"
        :fill="color" />
    </svg>
  </div>
</template>

<style scoped>
.loading-circle-icon {
  animation: rotate 0.75s linear infinite;
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
</style>